import React from 'react';
import { useGetFeaturedAgentsQuery } from '../../features/api/apiSlice';
import Icon from '../AppIcon';

const FeaturedAgentsStrip = () => {
  const { data: agents = [] } = useGetFeaturedAgentsQuery();
  if (!agents.length) return null;

  return (
    <section className="pb-10 sm:pb-12">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-700 mb-1">
        Featured agents
      </p>
      <h2 className="text-2xl font-bold text-slate-900 tracking-tight mb-4">Professionals paying for directory placement</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {agents.map((agent) => (
          <div key={agent.id} className="rounded-2xl border border-amber-200 bg-white p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-slate-100 overflow-hidden">
                {agent.profile ? <img src={agent.profile} alt="" className="w-full h-full object-cover" /> : null}
              </div>
              <div className="min-w-0">
                <p className="font-semibold text-slate-900 truncate">{agent.name}</p>
                <p className="text-xs text-slate-500 truncate">{agent.company_name || agent.account_role}</p>
              </div>
            </div>
            <span className="inline-flex items-center gap-1 mt-3 text-[10px] font-semibold uppercase tracking-wide text-amber-800 bg-amber-100 px-2 py-0.5 rounded-full">
              <Icon name="Star" size={11} /> Featured
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedAgentsStrip;
